import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../../../_actions/dataActions";
import Wrapper from "../../../../../../_hoc/Wrapper";
import PageSubTitle from "../../../../../UI/PageSubTitle";
import EditWidget from "../../../../../UI/EditWidget";
import Select from "../../../../../UI/Select";
import getEducation from "../../../../../../_selectors/dataSelectors/getEducation";
import getJobType from "../../../../../../_selectors/dataSelectors/getJobType";
import getEmployedIn from "../../../../../../_selectors/dataSelectors/getEmployedIn";
import getIncome from "../../../../../../_selectors/dataSelectors/getIncome";

class EducationDetail extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.userProfile) {
      const { education, jobType, employedIn, income } = nextProps.userProfile;
      const {
        isEditModeOn,
        selectedEducation,
        selectedEmployedIn,
        selectedIncome,
        selectedJobType
      } = prevState;

      if (isEditModeOn) {
        return null;
      } else {
        if (
          education !== selectedEducation ||
          jobType !== selectedJobType ||
          employedIn !== selectedEmployedIn ||
          income !== selectedIncome
        ) {
          return {
            selectedEducation: education,
            selectedEmployedIn: employedIn,
            selectedIncome: income,
            selectedJobType: jobType
          };
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  }
  state = {
    isEditModeOn: false,
    showEdit: this.props.showEdit,
    selectedEducation: null,
    selectedJobType: null,
    selectedEmployedIn: null,
    selectedIncome: null
  };
  componentDidMount() {
    const {
      education,
      jobType,
      employedIn,
      income,
      getEducationData,
      getJobTypeData,
      getEmployedInData,
      getIncomeData
    } = this.props;
    if (education.length === 0) {
      getEducationData();
    }
    if (jobType.length === 0) {
      getJobTypeData();
    }
    if (employedIn.length === 0) {
      getEmployedInData();
    }
    if (income.length === 0) {
      getIncomeData();
    }
  }
  disableEditMode = () => {
    this.setState({ isEditModeOn: false });
  };
  enableEditMode = () => {
    this.setState({ isEditModeOn: true });
  };
  save = () => {
    const {
      selectedEducation,
      selectedEmployedIn,
      selectedIncome,
      selectedJobType
    } = this.state;
    const { update, toast } = this.props;
    const updatedEducationDetail = {
      education: selectedEducation,
      jobType: selectedJobType,
      employedIn: selectedEmployedIn,
      income: selectedIncome
    };
    const onSuccess = () => {
      this.setState({ isEditModeOn: false });
      toast({ type: "info", message: "Profile Updated" });
    };
    const onError = err => {
      toast({ type: "error", message: err });
    };
    update({ data: updatedEducationDetail, onSuccess, onError });
  };
  render() {
    const {
      isEditModeOn,
      selectedEducation,
      selectedEmployedIn,
      selectedIncome,
      selectedJobType,
      showEdit
    } = this.state;
    const { education, jobType, employedIn, income, userProfile } = this.props;
    return (
      <Wrapper>
        <PageSubTitle>
          <h3>
            Education Detail
            <EditWidget
              edit={isEditModeOn}
              onEdit={this.enableEditMode}
              onSave={this.save}
              onCancel={this.disableEditMode}
              disabled={userProfile.cache}
              show={showEdit}
            />
          </h3>
          <p />
        </PageSubTitle>
        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-md-6">
              <Select
                label={<Wrapper>Highest Education</Wrapper>}
                selected={selectedEducation}
                options={education}
                onChange={value => {
                  this.setState({ selectedEducation: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-6">
              <Select
                label={<Wrapper>Job Type</Wrapper>}
                selected={selectedJobType}
                options={jobType}
                onChange={value => {
                  this.setState({ selectedJobType: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Select
                label={<Wrapper>Employed In</Wrapper>}
                selected={selectedEmployedIn}
                options={employedIn}
                onChange={value => {
                  this.setState({ selectedEmployedIn: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-6">
              <Select
                label={<Wrapper>Income</Wrapper>}
                selected={selectedIncome}
                options={income}
                onChange={value => {
                  this.setState({ selectedIncome: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  education: getEducation(state),
  jobType: getJobType(state),
  employedIn: getEmployedIn(state),
  income: getIncome(state)
});

const mapDispatchToProps = dispatch => ({
  getEducationData: () => dispatch(dataActions.getEducation()),
  getJobTypeData: () => dispatch(dataActions.getJobType()),
  getEmployedInData: () => dispatch(dataActions.getEmployedIn()),
  getIncomeData: () => dispatch(dataActions.getIncome())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EducationDetail);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Education/EducationDetail/index.js